
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/catalog/[...code]",
      function () {
        return require("private-next-pages/catalog/[...code].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/catalog/[...code]"])
      });
    }
  